import HowItWorkNav from "../menu/howitwork-nav";


const HowItWork = () => (
	<section id="howitwork-section" className="howitwork-section">
		<div className="holder">
			<div className="heading">
				<h2>How does it work?</h2>
			</div>
			<HowItWorkNav />
		</div>
	</section>
);

export default HowItWork;
